import {SVG} from '../../../constants/assetLists';
import {useOnBoardingLogout} from '../../../hooks/useOnBoardingLogout';
import FullScreenLoader from '../../common/FullScreenLoader';
import UserInfo from '../../Layout/components/UserInfo';
import DraftSaveStatus from './DraftSaveStatus';

function Header() {
  const {handleLogout, isLoggingOut} = useOnBoardingLogout();

  return (
    <>
      <FullScreenLoader open={isLoggingOut} />

      <div className="w-full h-[88px] bg-darkBlue flex gap-3 overflow-hidden relative z-20">
        <div className="px-4 w-[180px] h-full flex justify-start items-center">
          <img
            src={SVG.logoIcon}
            alt="logo"
            className="w-[140px] h-[62px] object-contain"
          />
        </div>

        <div className="px-4 flex-1 flex justify-between items-center gap-3 bg-darkerAqua">
          <div className="flex items-center gap-8">
            <div className="flex items-center gap-3">
              <img
                src={SVG.aquaStarIcon}
                alt="Filled Star Icon"
                className="w-5 h-5 object-contain"
              />
              <p className="m-0 text-xl text-white font-medium">הגדרת האתר</p>
            </div>

            <DraftSaveStatus />
          </div>

          <div className="flex justify-center items-center gap-4">
            <UserInfo />

            <button
              className="w-[24px] h-[24px] transition-opacity duration-200 hover:opacity-50"
              onClick={handleLogout}>
              <img
                src={SVG.logoutWhiteIcon}
                alt="icon"
                className="w-full h-full object-contain"
              />
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
